<div class="shell-container">
  <div>
      <img src="assets/images/shell/grey_circle_graphic.png" srcset="assets/images/shell/grey_circle_graphic@2x.png 2x" class="grey-circle-graphic" alt ="Graphic circle">
  </div>
 
  <div class="outer-container">
    <a
      href="#main-content"
      class="skip-to-main"
      (click)="skipToMain($event)"
    >{{ 'A11Y.SkipToMain' | translate }}</a>
    <smione-smione-header></smione-smione-header>
    <main id="main-content" class="main-content" tabindex="-1">
      <router-outlet></router-outlet>
    </main>
    <smione-smione-footer></smione-smione-footer>
  </div>
</div>


